import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import StatusBadge from "../components/StatusBadge";
import { Clock, Euro } from "lucide-react";

export default function OffersPage() {
  const { user } = useAuth();
  const [offers, setOffers] = useState([]);
  useEffect(() => { api.get("/offers").then((r) => setOffers(r.data)); }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="offers-page">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="text-[11px] uppercase tracking-widest font-bold text-orange-600">{user?.role === "pro" ? "Mes offres envoyées" : "Offres reçues"}</div>
          <h1 className="font-display font-extrabold text-3xl text-slate-900 tracking-tight">{user?.role === "pro" ? "Historique de mes offres" : "Toutes les offres"}</h1>

          <div className="mt-6 bg-white border border-slate-200 rounded-md divide-y divide-slate-200" data-testid="offers-table">
            {offers.length === 0 && <div className="p-8 text-center text-slate-500 text-sm">Aucune offre pour l'instant.</div>}
            {offers.map((o) => (
              <Link to={`/requests/${o.request_id}`} key={o.offer_id} className="flex flex-wrap items-center gap-4 p-4 hover:bg-slate-50 transition-colors">
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold text-slate-900">{user?.role === "pro" ? `Mission ${o.request_id}` : o.pro_name}</div>
                  <div className="text-xs text-slate-500 mt-0.5">
                    <Clock className="inline h-3 w-3 mr-1" />ETA {o.eta_minutes} min
                    <span className="mx-2 text-slate-300">·</span>
                    {new Date(o.created_at).toLocaleString("fr-FR")}
                  </div>
                </div>
                <div className="font-display font-extrabold text-xl text-slate-900"><Euro className="inline h-4 w-4" />{o.price_eur.toFixed(0)}</div>
                <StatusBadge status={o.status === "pending" ? "open" : o.status === "accepted" ? "accepted" : o.status === "rejected" ? "cancelled" : "open"} />
              </Link>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
